import { spline } from "@georgedoescode/spline";
import { createNoise2D } from "simplex-noise";

window.addEventListener("load", init);

function init() {
  initBlobs();
  lightboxImages();
}

function lightboxImages() {
  const imgs = document.querySelectorAll("img");
  const lin = document.getElementById("lightbox_inner");
  const lou = document.getElementById("lightbox_outer");
  [...imgs].map((img) => {
    const parent = img.parentNode;
    if (parent.nodeName == "A") {
      parent.addEventListener("click", (e) => {
        const href = parent.href;
        if (href.includes(".jpg")) {
          e.preventDefault();
          console.log(e, parent, href);
          const inode = document.createElement("IMG");
          inode.src = href;
          lin.appendChild(inode);
          lou.classList.add("show");
        }
      });
    }
  });

  lou.addEventListener("click", (e) => {
    console.log(e);
    if (e.target.id == "lightbox_outer") {
      hideLightbox();
    }
  });
  document.addEventListener("keydown", (e) => {
    if (e.key == "Escape") {
      hideLightbox();
    }
  });

  function hideLightbox() {
    lou.classList.remove("show");
    lin.innerHTML = "";
  }
}

function initBlobs() {
  const urlParams = new URLSearchParams(window.location.search);
  const pageParam = urlParams.get("page");
  document.body.classList.add(pageParam);

  const paths = document.querySelectorAll("path.blob");

  let pathsObj;
  const simplex = new createNoise2D();
  let noiseStep = 0.0009;
  if (document.body.scrollWidth < 600) {
    noiseStep = 0.0006;
  }
  const clipPath = document.getElementById("clipPath");
  function resetBlobs() {
    pathsObj = [...paths].map((p) => {
      let x = Math.random() * 300 + 0;
      let y = 160;
      let rad = Math.random() * 50 + 50;
      let ecc = 1;
      if ("main" in p.dataset) {
        x = 0;
        rad = 80;
        ecc = 2;
      }
      if ("x" in p.dataset) {
        x = parseInt(p.dataset.x, 10) + (Math.random() - 0.5) * 20;
      }
      if ("y" in p.dataset) {
        y = parseInt(p.dataset.y, 10) + (Math.random() - 0.5) * 20;
      }
      const slow = "slow" in p.dataset;
      const round = "round" in p.dataset;

      return {
        element: p,
        points: createPoints({ x, y, rad, ecc, slow, round }),
      };
    });
  }

  resetBlobs();

  document.body.addEventListener("click", (e) => {
    const el = e.target;
    if (el.nodeName === "path") {
      resetBlobs();
    }
  });

  (function animate() {
    pathsObj.forEach((pathobj, index) => {
      const is_main = "main" in pathobj.element.dataset;

      pathobj.points.forEach((point) => {
        updatePoint(point);
      });
      pathobj.element.setAttribute("d", spline(pathobj.points, 1, true));
      if (is_main) {
        const p = clipPath.querySelector("path");
        p.setAttribute("d", spline(pathobj.points, 1, true));
      }
    });

    requestAnimationFrame(animate);
  })();

  function updatePoint(point) {
    let nX = noise(point.noiseOffsetX, point.noiseOffsetX);
    let nY = noise(point.noiseOffsetY, point.noiseOffsetY);
    if (point.round) {
      nX *= 0.1;
      nY *= 0.1;
    }
    const size = 45;
    const x = map(nX, -1, 1, point.originX - size, point.originX + size);
    const y = map(nY, -1, 1, point.originY - size, point.originY + size);
    point.x = x;
    point.y = y;
    let ns = noiseStep;
    if (point.slow) {
      ns *= 0.3;
    }
    point.noiseOffsetX += ns;
    point.noiseOffsetY += ns;
  }

  function map(n, start1, end1, start2, end2) {
    return ((n - start1) / (end1 - start1)) * (end2 - start2) + start2;
  }

  function noise(x, y) {
    return simplex(x, y);
  }

  function createPoints(opts) {
    const points = [];
    // how many points do we need
    const numPoints = 6;
    // used to equally space each point around the circle
    const angleStep = (Math.PI * 2) / numPoints;
    // the radius of the circle
    const rad = opts.rad;
    const slow = opts.slow;
    const round = opts.round;

    for (let i = 1; i <= numPoints; i++) {
      // x & y coordinates of the current point
      const theta = i * angleStep;

      const x = opts.x + Math.cos(theta) * (rad * opts.ecc);
      const y = opts.y + Math.sin(theta) * rad;

      // store the point
      points.push({
        x: x,
        y: y,
        originX: x,
        originY: y,
        noiseOffsetX: Math.random() * 1000,
        noiseOffsetY: Math.random() * 1000,
        slow: slow,
        round: round,
      });
    }

    return points;
  }
}
